import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Api } from '../api/api';

/*
  Generated class for the AgendaProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AgendaProvider {
    constructor(private api: Api, public http: HttpClient) { }

    skipAgendaMasterRefresh = false;

    getStages(): Observable<any> {
        return this.http.get('assets/json/agenda.json');
    }
    getStages2(): Observable<any> {
        return this.http.get('assets/json/supervoice.json');
    }

    getAgenda(eventId: string): Observable<any> {
        return this.api.get(`events/${eventId}/agenda`)
            .map(res => {
                console.log('AGENDA', res)
                return res;
            });
    }

}



// WEBPACK FOOTER //
// ./src/providers/agenda/agenda.ts